"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function clientSupportsIO() {
    return (window &&
        window.IntersectionObserver &&
        window.IntersectionObserverEntry &&
        window.IntersectionObserverEntry.prototype &&
        "intersectionRatio" in window.IntersectionObserverEntry.prototype);
}
exports.default = clientSupportsIO;
